/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState, useCallback } from 'react';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import ReactSlider from 'react-slider';
import AppChip from '../../shared/components/app-chip/AppChip';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppCheckBox from '../../shared/components/app-check-box/AppCheckBox';
import AppLink from '../../shared/components/app-link/AppLink';
import { formatCurrency } from '../../shared/helper-utils/appUtils';
import { debounce } from '../../api/apiUtils';

function RoundTripFilters({
  minPrice,
  maxPrice,
  onwardCarriers,
  returnCarriers,
  selectedFilters,
  fareTypes,
  onApplyFilter,
  onTimeFormatChange,
  sectorInfo,
}) {
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const [selectedMinPrice, setSelectedMinPrice] = useState(
    selectedFilters.selectedMinPrice,
  );
  const [selectedMaxPrice, setSelectedMaxPrice] = useState(
    selectedFilters.selectedMaxPrice,
  );
  const [selectedOnwardStops, setSelectedOnwardStops] = useState(
    selectedFilters.selectedOnwardStops,
  );
  const [selectedReturnStops, setSelectedReturnStops] = useState(
    selectedFilters.selectedReturnStops,
  );
  const [selectedOnwardDepartureTimes, setSelectedOnwardDepartureTimes] =
    useState(selectedFilters.selectedOnwardDepartureTimes);
  const [selectedReturnDepartureTimes, setSelectedReturnDepartureTimes] =
    useState(selectedFilters.selectedReturnDepartureTimes);
  const [selectedOnwardArraivalTimes, setSelectedOnwardArraivalTimes] =
    useState(selectedFilters.selectedOnwardArraivalTimes);
  const [selectedReturnArraivalTimes, setSelectedReturnArraivalTimes] =
    useState(selectedFilters.selectedReturnArraivalTimes);
  const [selectedOnwardCarriers, setSelectedOnwardCarriers] = useState(
    selectedFilters.selectedOnwardCarriers,
  );
  const [selectedReturnCarriers, setSelectedReturnCarriers] = useState(
    selectedFilters.selectedReturnCarriers,
  );
  const [selectedFareTypes, setSelectedFareTypes] = useState(
    selectedFilters.selectedFareTypes,
  );
  const [selectedRefundStatus, setSelectedRefundStatus] = useState(
    selectedFilters.selectedRefundStatus,
  );
  const [selectedFlightNumber, setSelectedFlightNumber] = useState(
    selectedFilters.selectedFlightNumber,
  );
  const [isOnwardSameDayArraival, setIsOnwardSameDayArraival] = useState(
    selectedFilters.isOnwardSameDayArraival,
  );
  const [isReturnSameDayArraival, setIsReturnSameDayArraival] = useState(
    selectedFilters.isReturnSameDayArraival,
  );
  const [selectedEquipment, setSelectedEquipment] = useState(
    selectedFilters.selectedEquipment,
  );
  const [selectedAmPmFormat, setSelectedAamPmFormat] = useState(false);
  const [showPrice, setShowPrice] = useState(true);
  const [showStops, setSHowStops] = useState(true);
  const [showRefund, setShowRefund] = useState(true);
  const [showFareTypes, setShowFareTypes] = useState(true);
  const [showDepart, setShowDepart] = useState(true);
  const [showArrTimes, setShowArrTimes] = useState(true);
  const [showAirlines, setShowAirlines] = useState(true);
  const [showMoreOnwardCarriers, setShowMoreOnwardCarriers] = useState(false);
  const [showMoreReturnCarriers, setShowMoreReturnCarriers] = useState(false);
  const [showMoreFareTypes, setShowMoreFareTypes] = useState(false);
  const [showRefundStatus, setShowRefundStatus] = useState(true);

  useEffect(() => {
    const savedFilters = localStorage.getItem('flightFilters');
    if (savedFilters) {
      const parsed = JSON.parse(savedFilters);
      setSelectedMinPrice(parsed.selectedMinPrice);
      setSelectedMaxPrice(parsed.selectedMaxPrice);
      // ...set other saved filters if needed
    } else {
      // Only use props if no saved filters
      setSelectedMinPrice(minPrice);
      setSelectedMaxPrice(maxPrice);
    }
  }, [minPrice, maxPrice]);

  const debouncedApply = useCallback(
    debounce((filters) => {
      onApplyFilter(filters);
    }, 300),
    [],
  );

  useEffect(() => {
    debouncedApply({
      selectedMinPrice,
      selectedMaxPrice,
      selectedOnwardStops,
      selectedReturnStops,
      selectedOnwardDepartureTimes,
      selectedReturnDepartureTimes,
      selectedOnwardArraivalTimes,
      selectedReturnArraivalTimes,
      selectedOnwardCarriers,
      selectedReturnCarriers,
      selectedFareTypes,
      selectedRefundStatus,
      selectedFlightNumber,
      selectedEquipment,
      isOnwardSameDayArraival,
      isReturnSameDayArraival,
    });
  }, [
    selectedMinPrice,
    selectedMaxPrice,
    selectedOnwardStops,
    selectedReturnStops,
    selectedOnwardDepartureTimes,
    selectedReturnDepartureTimes,
    selectedOnwardArraivalTimes,
    selectedReturnArraivalTimes,
    selectedOnwardCarriers,
    selectedReturnCarriers,
    selectedFareTypes,
    selectedRefundStatus,
    selectedFlightNumber,
    selectedEquipment,
    isOnwardSameDayArraival,
    isReturnSameDayArraival,
  ]);

  const handleChipSelection = (name, value) => {
    let list = [];
    if (name === 'onwardstops') {
      list = [...selectedOnwardStops];
    } else if (name === 'returnstops') {
      list = [...selectedReturnStops];
    } else if (name === 'onwardDepTime') {
      list = [...selectedOnwardDepartureTimes];
    } else if (name === 'returnDepTime') {
      list = [...selectedReturnDepartureTimes];
    } else if (name === 'onwardArrTime') {
      list = [...selectedOnwardArraivalTimes];
    } else if (name === 'returnArrTime') {
      list = [...selectedReturnArraivalTimes];
    } else if (name === 'onwardCarrier') {
      list = [...selectedOnwardCarriers];
    } else if (name === 'returnCarrier') {
      list = [...selectedReturnCarriers];
    } else if (name === 'fareType') {
      list = [...selectedFareTypes];
    } else if (name === 'refundStatus') {
      list = [...selectedRefundStatus];
    }
    const index = list.indexOf(value);
    if (index > -1) {
      list.splice(index, 1);
    } else {
      list.push(value);
    }
    if (name === 'onwardstops') {
      setSelectedOnwardStops(list);
    } else if (name === 'returnstops') {
      setSelectedReturnStops(list);
    } else if (name === 'onwardDepTime') {
      setSelectedOnwardDepartureTimes(list);
    } else if (name === 'returnDepTime') {
      setSelectedReturnDepartureTimes(list);
    } else if (name === 'onwardArrTime') {
      setSelectedOnwardArraivalTimes(list);
    } else if (name === 'returnArrTime') {
      setSelectedReturnArraivalTimes(list);
    } else if (name === 'onwardCarrier') {
      setSelectedOnwardCarriers(list);
    } else if (name === 'returnCarrier') {
      setSelectedReturnCarriers(list);
    } else if (name === 'fareType') {
      setSelectedFareTypes(list);
    } else if (name === 'refundStatus') {
      setSelectedRefundStatus(list);
    }
  };
  const handleSliderChange = (newValues) => {
    setSelectedMinPrice(newValues[0]);
    setSelectedMaxPrice(newValues[1]);
  };

  const handleTimeFormatChange = () => {
    const isAmPmFormat = selectedAmPmFormat;
    setSelectedAamPmFormat((prev) => !prev);
    onTimeFormatChange(!isAmPmFormat);
  };

  const handleClearPrice = () => {
    setSelectedMinPrice(minPrice);
    setSelectedMaxPrice(maxPrice);
  };

  const handleClearStops = () => {
    setSelectedOnwardStops([]);
    setSelectedReturnStops([]);
    setIsOnwardSameDayArraival(false);
    setIsReturnSameDayArraival(false);
  };

  const handleClearRefund = () => {
    setSelectedAamPmFormat(false);
    setSelectedRefundStatus([]);
  };

  const handleClearDepart = () => {
    setSelectedOnwardDepartureTimes([]);
    setSelectedReturnDepartureTimes([]);
  };
  const handleClearArr = () => {
    setSelectedOnwardArraivalTimes([]);
    setSelectedReturnArraivalTimes([]);
  };

  const handleClearAirlines = () => {
    setSelectedOnwardCarriers([]);
    setSelectedReturnCarriers([]);
  };

  return (
    <section className="one-way-flight-filters text-uppercase">
      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header d-flex justify-content-between align-items-center">
          <FormattedMessage id="search_by_airlines" />
          <div className="d-flex gap-2 align-items-center fw-500">
            <AppLink
              linkText="Clear"
              className="fs-12"
              onClick={handleClearAirlines}
            />
            <AppLink
              linkText={
                showAirlines ? <MdKeyboardArrowDown /> : <MdKeyboardArrowUp />
              }
              variant="secondary"
              onClick={() => setShowAirlines((prev) => !prev)}
            />
          </div>
        </div>
        {showAirlines && (
          <div className="d-flex">
            <div className="flex-1">
              <div className="one-way-flight-filters_section_header">
                {sectorInfo.split('-')[0]}- {sectorInfo.split('-')[1]}
              </div>
              <div className="one-way-flight-filters_section_content d-flex flex-column gap-2">
                {onwardCarriers.length > 10 ? (
                  <>
                    {onwardCarriers.slice(0, 10).map((c, index) => (
                      <AppCheckBox
                        key={index}
                        onChange={() =>
                          handleChipSelection(
                            'onwardCarrier',
                            c.validatingcarriername,
                          )
                        }
                        name="onwardCarrier"
                        id={c.validatingcarriername}
                        labelText={`${c.validatingcarriername} (${c.validatingcarrier})`}
                        checked={
                          selectedOnwardCarriers.indexOf(
                            c.validatingcarriername,
                          ) > -1
                        }
                        radioClassName="roundTripDept"
                        labelClassName="rounTripDeptlabel"
                      />
                    ))}
                    {!showMoreOnwardCarriers && (
                      <AppLink
                        linkText="Show More"
                        className="fs-12 showMoreOnwardAirlines"
                        onClick={() => setShowMoreOnwardCarriers(true)}
                      />
                    )}
                    {showMoreOnwardCarriers && (
                      <>
                        {onwardCarriers
                          .slice(10, onwardCarriers.length)
                          .map((c, index) => (
                            <AppCheckBox
                              key={index}
                              onChange={() =>
                                handleChipSelection(
                                  'onwardCarrier',
                                  c.validatingcarriername,
                                )
                              }
                              name="onwardCarrier"
                              id={c.validatingcarriername}
                              labelText={`${c.validatingcarriername} (${c.validatingcarrier})`}
                              checked={
                                selectedOnwardCarriers.indexOf(
                                  c.validatingcarriername,
                                ) > -1
                              }
                              radioClassName="roundTripDept"
                              labelClassName="rounTripDeptlabel"
                            />
                          ))}
                        <AppLink
                          linkText="Show Less"
                          className="fs-12"
                          onClick={() => setShowMoreOnwardCarriers(false)}
                        />
                      </>
                    )}
                  </>
                ) : (
                  onwardCarriers.map((c, index) => (
                    <AppCheckBox
                      key={index}
                      onChange={() =>
                        handleChipSelection(
                          'onwardCarrier',
                          c.validatingcarriername,
                        )
                      }
                      name="onwardCarrier"
                      id={c.validatingcarriername}
                      labelText={`${c.validatingcarriername} (${c.validatingcarrier})`}
                      checked={
                        selectedOnwardCarriers.indexOf(
                          c.validatingcarriername,
                        ) > -1
                      }
                      radioClassName="roundTripDept"
                      labelClassName="rounTripDeptlabel"
                    />
                  ))
                )}
              </div>
            </div>
            <div className="flex-1">
              <div className="one-way-flight-filters_section_header">
                {sectorInfo.split('-')[1]}- {sectorInfo.split('-')[0]}
              </div>
              <div className="one-way-flight-filters_section_content d-flex flex-column gap-2">
                {returnCarriers.length > 10 ? (
                  <>
                    {returnCarriers.slice(0, 10).map((c, index) => (
                      <AppCheckBox
                        key={index}
                        onChange={() =>
                          handleChipSelection(
                            'returnCarrier',
                            c.validatingcarriername,
                          )
                        }
                        name="returnCarrier"
                        id={c.validatingcarriername}
                        labelText={`${c.validatingcarriername} (${c.validatingcarrier})`}
                        checked={
                          selectedReturnCarriers.indexOf(
                            c.validatingcarriername,
                          ) > -1
                        }
                        radioClassName="roundTripArr"
                        labelClassName="rounDtripArrlable"
                      />
                    ))}
                    {!showMoreReturnCarriers && (
                      <AppLink
                        linkText="Show More"
                        className="fs-12 showMoreReturnAirlines"
                        onClick={() => setShowMoreReturnCarriers(true)}
                      />
                    )}
                    {showMoreReturnCarriers && (
                      <>
                        {returnCarriers
                          .slice(10, returnCarriers.length)
                          .map((c) => (
                            <AppCheckBox
                              key={c.validatingcarriername}
                              onChange={() =>
                                handleChipSelection(
                                  'returnCarrier',
                                  c.validatingcarriername,
                                )
                              }
                              name="returnCarrier"
                              id={c.validatingcarriername}
                              labelText={`${c.validatingcarriername} (${c.validatingcarrier})`}
                              checked={
                                selectedReturnCarriers.indexOf(
                                  c.validatingcarriername,
                                ) > -1
                              }
                              radioClassName="roundTripArr"
                              labelClassName="rounDtripArrlable"
                            />
                          ))}
                        <AppLink
                          linkText="Show Less"
                          className="fs-12 showMoreReturnAirlines"
                          onClick={() => setShowMoreReturnCarriers(false)}
                        />
                      </>
                    )}
                  </>
                ) : (
                  returnCarriers.map((c) => (
                    <AppCheckBox
                      key={c.validatingcarriername}
                      onChange={() =>
                        handleChipSelection(
                          'returnCarrier',
                          c.validatingcarriername,
                        )
                      }
                      name="returnCarrier"
                      id={c.validatingcarriername}
                      labelText={`${c.validatingcarriername} (${c.validatingcarrier})`}
                      checked={
                        selectedReturnCarriers.indexOf(
                          c.validatingcarriername,
                        ) > -1
                      }
                      radioClassName="roundTripArr"
                      labelClassName="rounDtripArrlable"
                    />
                  ))
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header justify-content-between d-flex align-items-center">
          <FormattedMessage id="price_range" />
          <div className="d-flex gap-2 align-items-center fw-500">
            <AppLink
              linkText="Clear"
              className="fs-12"
              onClick={handleClearPrice}
            />
            <AppLink
              linkText={
                showPrice ? <MdKeyboardArrowDown /> : <MdKeyboardArrowUp />
              }
              variant="secondary"
              onClick={() => setShowPrice((prev) => !prev)}
            />
          </div>
        </div>
        <div>
          <span className="fs-12">
            {formatCurrency(selectedMinPrice)}-
            {formatCurrency(selectedMaxPrice)}
          </span>
        </div>
        {showPrice && (
          <div className="my-3">
            <ReactSlider
              min={Math.floor(minPrice)}
              max={Math.round(maxPrice)}
              value={[selectedMinPrice, selectedMaxPrice]}
              onChange={handleSliderChange}
            />
          </div>
        )}
      </div>
      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header justify-content-between d-flex  align-items-center">
          Stops
          <div className="d-flex gap-2 align-items-center fw-500 ">
            <AppLink
              linkText="Clear"
              className="fs-12"
              onClick={handleClearStops}
            />
            <AppLink
              linkText={
                showStops ? <MdKeyboardArrowDown /> : <MdKeyboardArrowUp />
              }
              variant="secondary"
              onClick={() => setSHowStops((prev) => !prev)}
            />
          </div>
        </div>
        {showStops && (
          <div className="d-flex">
            <div className="flex-1">
              <div className="one-way-flight-filters_section_header">
                {sectorInfo.split('-')[0]}- {sectorInfo.split('-')[1]}
              </div>
              <div className="one-way-flight-filters_section_content d-flex flex-column gap-2">
                <AppCheckBox
                  onChange={() => handleChipSelection('onwardstops', '0')}
                  name="onwardstops"
                  id="0"
                  labelText={formattedMessage('non_stop')}
                  checked={selectedOnwardStops.indexOf('0') > -1}
                  radioClassName="onwardNonStopFilter"
                />
                <AppCheckBox
                  onChange={() => handleChipSelection('onwardstops', '1')}
                  name="onwardstops"
                  id="1"
                  labelText={formattedMessage('one_stop')}
                  checked={selectedOnwardStops.indexOf('1') > -1}
                  radioClassName="onwardOneStopFilter"
                />
                <AppCheckBox
                  onChange={() => setIsOnwardSameDayArraival((prev) => !prev)}
                  name="isOnwardSameDayArraival"
                  id="isOnwardSameDayArraival"
                  labelText={formattedMessage('same_day_arraival')}
                  checked={isOnwardSameDayArraival}
                />
              </div>
            </div>
            <div className="flex-1">
              <div className="one-way-flight-filters_section_header">
                {sectorInfo.split('-')[1]}- {sectorInfo.split('-')[0]}
              </div>
              <div className="one-way-flight-filters_section_content d-flex flex-column gap-2">
                <AppCheckBox
                  onChange={() => handleChipSelection('returnstops', '0')}
                  name="returnstops"
                  id="0"
                  labelText={formattedMessage('non_stop')}
                  checked={selectedReturnStops.indexOf('0') > -1}
                  radioClassName="returnNonStopFilter"
                />
                <AppCheckBox
                  onChange={() => handleChipSelection('returnstops', '1')}
                  name="returnstops"
                  id="1"
                  labelText={formattedMessage('one_stop')}
                  checked={selectedReturnStops.indexOf('1') > -1}
                  radioClassName="returnOneStopFilter"
                />
                <AppCheckBox
                  onChange={() => setIsReturnSameDayArraival((prev) => !prev)}
                  name="isReturnSameDayArraival"
                  id="isReturnSameDayArraival"
                  labelText={formattedMessage('same_day_arraival')}
                  checked={isReturnSameDayArraival}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header d-flex justify-content-between align-items-center">
          <FormattedMessage id="fare_types" />
          <div className="d-flex gap-2 align-items-center fw-500">
            <AppLink
              linkText="Clear"
              className="fs-12"
              onClick={() => setSelectedFareTypes([])}
            />
            <AppLink
              linkText={
                showFareTypes ? <MdKeyboardArrowDown /> : <MdKeyboardArrowUp />
              }
              variant="secondary"
              onClick={() => setShowFareTypes((prev) => !prev)}
            />
          </div>
        </div>

        {showFareTypes && (
          <div className="one-way-flight-filters_section_content d-flex flex-column gap-2">
            {fareTypes.length > 10 ? (
              <>
                {fareTypes.slice(0, 10).map((fare) => (
                  <AppCheckBox
                    key={fare}
                    onChange={() => handleChipSelection('fareType', fare)}
                    name="fareType"
                    id={fare}
                    labelText={fare}
                    checked={selectedFareTypes.indexOf(fare) > -1}
                  />
                ))}
                {!showMoreFareTypes && (
                  <AppLink
                    linkText="Show More"
                    className="fs-12"
                    onClick={() => setShowMoreFareTypes(true)}
                  />
                )}
                {showMoreFareTypes && (
                  <>
                    {fareTypes.slice(10, fareTypes.length).map((fare) => (
                      <AppCheckBox
                        key={fare}
                        onChange={() => handleChipSelection('fareType', fare)}
                        name="fareType"
                        id={fare}
                        labelText={fare}
                        checked={selectedFareTypes.indexOf(fare) > -1}
                      />
                    ))}
                    <AppLink
                      linkText="Show Less"
                      className="fs-12"
                      onClick={() => setShowMoreFareTypes(false)}
                    />
                  </>
                )}
              </>
            ) : (
              fareTypes.map((fare) => (
                <AppCheckBox
                  key={fare}
                  onChange={() => handleChipSelection('fareType', fare)}
                  name="fareType"
                  id={fare}
                  labelText={fare}
                  checked={selectedFareTypes.indexOf(fare) > -1}
                />
              ))
            )}
          </div>
        )}
      </div>
      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header d-flex justify-content-between align-items-center">
          Refundable Info
          <div className="d-flex gap-2 align-items-center fw-500">
            <AppLink
              linkText="Clear"
              className="fs-12"
              onClick={handleClearRefund}
            />
            <AppLink
              linkText={
                showRefundStatus ? (
                  <MdKeyboardArrowDown />
                ) : (
                  <MdKeyboardArrowUp />
                )
              }
              variant="secondary"
              onClick={() => setShowRefundStatus((prev) => !prev)}
            />
          </div>
        </div>
        {showRefundStatus && (
          <div className="one-way-flight-filters_section_content d-flex flex-column gap-2">
            <AppCheckBox
              onChange={() => handleChipSelection('refundStatus', 'Y')}
              name="refundStatus"
              id="Y"
              labelText={formattedMessage('is_refundable')}
              checked={selectedRefundStatus.indexOf('Y') > -1}
            />
            <AppCheckBox
              onChange={() => handleChipSelection('refundStatus', 'N')}
              name="refundStatus"
              id="N"
              labelText="Non-Refundable"
              checked={selectedRefundStatus.indexOf('N') > -1}
            />
            <AppCheckBox
              onChange={handleTimeFormatChange}
              name="amPmFormat"
              id="amPmFormat"
              labelText={formattedMessage('am_pm_format')}
              checked={selectedAmPmFormat === true}
            />
          </div>
        )}
      </div>
      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header d-flex justify-content-between align-items-center">
          {`${formattedMessage('depart_time')}`}{' '}
          <div className="d-flex gap-2 align-items-center fw-500">
            <AppLink
              linkText="Clear"
              className="fs-12"
              onClick={handleClearDepart}
            />
            <AppLink
              linkText={
                showDepart ? <MdKeyboardArrowDown /> : <MdKeyboardArrowUp />
              }
              variant="secondary"
              onClick={() => setShowDepart((prev) => !prev)}
            />
          </div>
        </div>

        {showDepart && (
          <div className="d-flex">
            <div className="flex-1">
              <div className="one-way-flight-filters_section_header text-center">
                {sectorInfo.split('-')[0]}- {sectorInfo.split('-')[1]}
              </div>
              <div className="one-way-flight-filters_section_content d-flex flex-column">
                <AppChip
                  selected={
                    selectedOnwardDepartureTimes.indexOf('0000-0599') > -1
                  }
                  name="onwardDepTime"
                  chipText={
                    <div className="d-flex gap-1 align-items-center justify-content-center">
                      <img src="/images/others/sunrise.svg" alt="" />
                      <span>00 -06</span>
                    </div>
                  }
                  value="0000-0599"
                  className="m-1 text-center flex-1"
                  onClick={handleChipSelection}
                />
                <AppChip
                  selected={
                    selectedOnwardDepartureTimes.indexOf('0600-1199') > -1
                  }
                  name="onwardDepTime"
                  chipText={
                    <div className="d-flex gap-1 align-items-center justify-content-center">
                      <img src="/images/others/afternoon_sun.svg" alt="" />
                      <span>06 -12</span>
                    </div>
                  }
                  value="0600-1199"
                  className="m-1 text-center flex-1"
                  onClick={handleChipSelection}
                />
                <AppChip
                  selected={
                    selectedOnwardDepartureTimes.indexOf('1200-1799') > -1
                  }
                  name="onwardDepTime"
                  chipText={
                    <div className="d-flex gap-1 align-items-center justify-content-center">
                      <img src="/images/others/evening_time.svg" alt="" />
                      <span>12-18</span>
                    </div>
                  }
                  value="1200-1799"
                  className="m-1 text-center flex-1"
                  onClick={handleChipSelection}
                />
                <AppChip
                  selected={
                    selectedOnwardDepartureTimes.indexOf('1800-2399') > -1
                  }
                  name="onwardDepTime"
                  chipText={
                    <div className="d-flex gap-1 align-items-center justify-content-center">
                      <img src="/images/others/night_time.svg" alt="" />
                      <span>18-00</span>
                    </div>
                  }
                  value="1800-2399"
                  className="m-1 text-center flex-1"
                  onClick={handleChipSelection}
                />
              </div>
            </div>
            <div className="flex-1">
              <div className="one-way-flight-filters_section_header text-center">
                {sectorInfo.split('-')[1]}- {sectorInfo.split('-')[0]}
              </div>
              <div className="one-way-flight-filters_section_content d-flex flex-column">
                <AppChip
                  selected={
                    selectedReturnDepartureTimes.indexOf('0000-0599') > -1
                  }
                  name="returnDepTime"
                  chipText={
                    <div className="d-flex gap-1 align-items-center justify-content-center">
                      <img src="/images/others/sunrise.svg" alt="" />
                      <span>00 -06</span>
                    </div>
                  }
                  value="0000-0599"
                  className="m-1 text-center flex-1"
                  onClick={handleChipSelection}
                />
                <AppChip
                  selected={
                    selectedReturnDepartureTimes.indexOf('0600-1199') > -1
                  }
                  name="returnDepTime"
                  chipText={
                    <div className="d-flex gap-1 align-items-center justify-content-center">
                      <img src="/images/others/afternoon_sun.svg" alt="" />
                      <span>06 -12</span>
                    </div>
                  }
                  value="0600-1199"
                  className="m-1 text-center flex-1"
                  onClick={handleChipSelection}
                />
                <AppChip
                  selected={
                    selectedReturnDepartureTimes.indexOf('1200-1799') > -1
                  }
                  name="returnDepTime"
                  chipText={
                    <div className="d-flex gap-1 align-items-center justify-content-center">
                      <img src="/images/others/evening_time.svg" alt="" />
                      <span>12-18</span>
                    </div>
                  }
                  value="1200-1799"
                  className="m-1 text-center flex-1"
                  onClick={handleChipSelection}
                />
                <AppChip
                  selected={
                    selectedReturnDepartureTimes.indexOf('1800-2399') > -1
                  }
                  name="returnDepTime"
                  chipText={
                    <div className="d-flex gap-1 align-items-center justify-content-center">
                      <img src="/images/others/night_time.svg" alt="" />
                      <span>18-00</span>
                    </div>
                  }
                  value="1800-2399"
                  className="m-1 text-center flex-1"
                  onClick={handleChipSelection}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header d-flex justify-content-between align-items-center">
          {` ${formattedMessage('arraival_time')}`}
          <div className="d-flex gap-2 align-items-center fw-500">
            <AppLink
              linkText="Clear"
              className="fs-12"
              onClick={handleClearArr}
            />
            <AppLink
              linkText={
                showArrTimes ? <MdKeyboardArrowDown /> : <MdKeyboardArrowUp />
              }
              variant="secondary"
              onClick={() => setShowArrTimes((prev) => !prev)}
            />
          </div>
        </div>
        {showArrTimes && (
          <div className="d-flex">
            <div className="flex-1">
              <div className="one-way-flight-filters_section_header text-center">
                {sectorInfo.split('-')[0]}- {sectorInfo.split('-')[1]}
              </div>
              <div className="one-way-flight-filters_section_content d-flex flex-column">
                <AppChip
                  selected={
                    selectedOnwardArraivalTimes.indexOf('0000-0599') > -1
                  }
                  name="onwardArrTime"
                  chipText={
                    <div className="d-flex gap-1 align-items-center justify-content-center">
                      <img src="/images/others/sunrise.svg" alt="" />
                      <span>00 -06</span>
                    </div>
                  }
                  value="0000-0599"
                  className="m-1 text-center flex-1"
                  onClick={handleChipSelection}
                />
                <AppChip
                  selected={
                    selectedOnwardArraivalTimes.indexOf('0600-1199') > -1
                  }
                  name="onwardArrTime"
                  chipText={
                    <div className="d-flex gap-1 align-items-center justify-content-center">
                      <img src="/images/others/afternoon_sun.svg" alt="" />
                      <span>06 -12</span>
                    </div>
                  }
                  value="0600-1199"
                  className="m-1 text-center flex-1"
                  onClick={handleChipSelection}
                />
                <AppChip
                  selected={
                    selectedOnwardArraivalTimes.indexOf('1200-1799') > -1
                  }
                  name="onwardArrTime"
                  chipText={
                    <div className="d-flex gap-1 align-items-center justify-content-center">
                      <img src="/images/others/evening_time.svg" alt="" />
                      <span>12-18</span>
                    </div>
                  }
                  value="1200-1799"
                  className="m-1 text-center flex-1"
                  onClick={handleChipSelection}
                />
                <AppChip
                  selected={
                    selectedOnwardArraivalTimes.indexOf('1800-2399') > -1
                  }
                  name="onwardArrTime"
                  chipText={
                    <div className="d-flex gap-1 align-items-center justify-content-center">
                      <img src="/images/others/night_time.svg" alt="" />
                      <span>18-00</span>
                    </div>
                  }
                  value="1800-2399"
                  className="m-1 text-center flex-1"
                  onClick={handleChipSelection}
                />
              </div>
            </div>
            <div className="flex-1">
              <div className="one-way-flight-filters_section_header text-center">
                {sectorInfo.split('-')[1]}- {sectorInfo.split('-')[0]}
              </div>
              <div className="one-way-flight-filters_section_content d-flex flex-column">
                <AppChip
                  selected={
                    selectedReturnArraivalTimes.indexOf('0000-0599') > -1
                  }
                  name="returnArrTime"
                  chipText={
                    <div className="d-flex gap-1 align-items-center justify-content-center">
                      <img src="/images/others/sunrise.svg" alt="" />
                      <span>00 -06</span>
                    </div>
                  }
                  value="0000-0599"
                  className="m-1 text-center flex-1"
                  onClick={handleChipSelection}
                />
                <AppChip
                  selected={
                    selectedReturnArraivalTimes.indexOf('0600-1199') > -1
                  }
                  name="returnArrTime"
                  chipText={
                    <div className="d-flex gap-1 align-items-center justify-content-center">
                      <img src="/images/others/afternoon_sun.svg" alt="" />
                      <span>06 -12</span>
                    </div>
                  }
                  value="0600-1199"
                  className="m-1 text-center flex-1"
                  onClick={handleChipSelection}
                />
                <AppChip
                  selected={
                    selectedReturnArraivalTimes.indexOf('1200-1799') > -1
                  }
                  name="returnArrTime"
                  chipText={
                    <div className="d-flex gap-1 align-items-center justify-content-center">
                      <img src="/images/others/evening_time.svg" alt="" />
                      <span>12-18</span>
                    </div>
                  }
                  value="1200-1799"
                  className="m-1 text-center flex-1"
                  onClick={handleChipSelection}
                />
                <AppChip
                  selected={
                    selectedReturnArraivalTimes.indexOf('1800-2399') > -1
                  }
                  name="returnArrTime"
                  chipText={
                    <div className="d-flex gap-1 align-items-center justify-content-center">
                      <img src="/images/others/night_time.svg" alt="" />
                      <span>18-00</span>
                    </div>
                  }
                  value="1800-2399"
                  className="m-1 text-center flex-1"
                  onClick={handleChipSelection}
                />
              </div>
            </div>
          </div>
        )}
        <div className="one-way-flight-filters_section">
          <AppTextInput
            label="Filter by Flight Number"
            placeholderText="Eg: QP-571"
            className="filterByFlightNumber"
            value={selectedFlightNumber}
            onChange={(e) => setSelectedFlightNumber(e.target.value)}
          />
        </div>
        <div className="one-way-flight-filters_section">
          <AppTextInput
            label="Filter By Aircraft Type"
            placeholderText="Eg: 380,777"
            value={selectedEquipment}
            onChange={(e) => setSelectedEquipment(e.target.value)}
          />
        </div>
      </div>
    </section>
  );
}

RoundTripFilters.propTypes = {
  minPrice: PropTypes.number.isRequired,
  maxPrice: PropTypes.number.isRequired,
  returnCarriers: PropTypes.array.isRequired,
  onwardCarriers: PropTypes.array.isRequired,
  fareTypes: PropTypes.array.isRequired,
  selectedFilters: PropTypes.object.isRequired,
  onApplyFilter: PropTypes.func.isRequired,
  onTimeFormatChange: PropTypes.func.isRequired,
  sectorInfo: PropTypes.any.isRequired,
};

export default RoundTripFilters;
